// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._17d4pxbi ul{margin-left:var(--ds-space-200,1pc)}\n._19bvidpf{padding-left:0}", ""]);
// Exports
module.exports = exports;
